import { Pipe, PipeTransform } from '@angular/core';
import { OrderedItem, OrderedChoice } from 'ngx-web-api';

@Pipe({
  name: 'orderedChoice',
})
export class OrderedChoicePipe implements PipeTransform {
  transform(item: OrderedItem, choiceName: string): OrderedChoice {
    if (!!item && !!choiceName) {
      return item.getChoice(choiceName);
    }
    return null;
  }
}
